import { render, staticRenderFns } from "./MunicipalwastePassport.vue?vue&type=template&id=1701ddf4&scoped=true&"
import script from "./MunicipalwastePassport.vue?vue&type=script&lang=js&"
export * from "./MunicipalwastePassport.vue?vue&type=script&lang=js&"
import style0 from "./MunicipalwastePassport.vue?vue&type=style&index=0&id=1701ddf4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1701ddf4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VCardText,VCol,VRow,VSelect,VTextField})
